import { Angry, Mars, Venus } from "lucide-react";
import React from "react";
import { weightClasses } from "../constants";
import { twMerge } from "tailwind-merge";
import { getEventFighterWeightClass } from "../utils/common";
import { MANAGE_FIGHTERS_PATH } from "../App";

export default function FighterMatchingCard({ eventFighter, className }) {
    console.log(eventFighter);
    return (
        <div className={twMerge("flex flex-col w-full gap-4", className)}>
            <div className="w-full flex flex-row gap-4 items-center">
                <button className="aspect-square w-12 group" onClick={() => {
                    // open in new tab
                    window.open(`${MANAGE_FIGHTERS_PATH}?fighter=${eventFighter?.fighter?.id}`, "_blank");
                }}>
                    <img
                        className="w-full h-full object-cover object-center max-w-24 group-hover:hidden"
                        src={eventFighter?.fighter?.fighterPicture}
                        alt=""
                    />
                    <Angry className="w-full h-full object-cover object-center max-w-24 hidden p-1 border group-hover:block" />
                </button>
                <div className="flex flex-col w-full">
                    <p className="font-bold text-lg flex gap-2 group">
                        <span>
                        {eventFighter?.fighter?.name}
                        </span>

                        {eventFighter?.fighter?.gender?.toUpperCase() ===
                        "M" ? (
                            <Mars className="text-blue-300" />
                        ) : eventFighter?.fighter?.gender?.toUpperCase() ===
                          "F" ? (
                            <Venus className="text-pink-300" />
                        ) : (
                            "?"
                        )}
                    </p>
                    <p className="opacity-70 text-sm">
                        {eventFighter?.entry ?? "???"} | {eventFighter?.fighter?.gymNameOrTeamName ?? "???"}
                    </p>
                </div>
            </div>
            <table className="table">
                <tbody>
                    <tr>
                        <th className="text-start">Age</th>
                        <td className="text-start">
                            {eventFighter?.fighter?.age ?? "???"}
                        </td>
                    </tr>
                    <tr>
                        <th className="text-start">Weight</th>
                        <td className="text-start">
                            {(() => {
                                const wc =
                                    getEventFighterWeightClass(eventFighter);
                                return wc
                                    ? `${wc}: ${weightClasses[wc]}`
                                    : "?: ???";
                            })()}
                        </td>
                    </tr>
                    <tr>
                        <th className="text-start">Height</th>
                        <td className="text-start">
                            {eventFighter?.fighter?.height ?? "???"} CM
                        </td>
                    </tr>
                    <tr>
                        <th className="text-start">Record</th>
                        <td className="text-start">
                            <div className="flex w-full justify-around">
                                W:
                                <span className="font-bold">
                                    {eventFighter?.fighter?.records[
                                        eventFighter?.entry ?? "?"
                                    ]?.win ?? "?"}
                                </span>
                                <div className="divider divider-horizontal m-0" />
                                L:
                                <span className="font-bold">
                                    {eventFighter?.fighter?.records[
                                        eventFighter?.entry ?? "?"
                                    ]?.loss ?? "?"}
                                </span>
                                <div className="divider divider-horizontal m-0" />
                                D:
                                <span className="font-bold">
                                    {eventFighter?.fighter?.records[
                                        eventFighter?.entry ?? "?"
                                    ]?.draw ?? "?"}
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
